(function(){
'use strict';

function normalizeText(value){
  return String(value||'')
    .toLowerCase()
    .replace(/&/g,' and ')
    .replace(/[’‘]/g,"'")
    .replace(/[^a-z0-9]+/g,' ')
    .trim()
    .replace(/\s+/g,' ');
}

function normalizeSystem(value){
  const raw=normalizeText(value);
  const aliases={
    'wii':'nintendo wii',
    'wii u':'nintendo wii u',
    'gamecube':'nintendo gamecube',
    'nintendo game cube':'nintendo gamecube',
    'xbox':'og xbox',
    'xbox original':'og xbox',
    'original xbox':'og xbox',
    'playstation':'playstation 1',
    'ps1':'playstation 1',
    'ps2':'playstation 2',
    'ps3':'playstation 3',
    'ps4':'playstation 4',
    'ps5':'playstation 5',
    'ps vita':'playstation vita',
    'sony psp':'psp',
    'playstation portable':'psp',
    'xbox series':'xbox series s and x',
    'xbox series x':'xbox series s and x',
    'xbox series s':'xbox series s and x',
    'xbox series x s':'xbox series s and x',
    'nintendo gba':'nintendo game boy advance',
    'gba':'nintendo game boy advance',
    'game boy advance':'nintendo game boy advance',
    'gameboy advance':'nintendo game boy advance',
    'game boy':'nintendo game boy',
    'game boy color':'nintendo game boy color',
    'sega genesis':'sega genesis',
    'genesis':'sega genesis',
    'dreamcast':'sega dreamcast',
    'saturn':'sega saturn',
    'game gear':'sega game gear'
  };
  return aliases[raw]||raw;
}

function exactBuyListMatch(title,platform){
  const data=Array.isArray(window.ZYPHER_BUY_LIST_DATA)?window.ZYPHER_BUY_LIST_DATA:[];
  if(!data.length||!title||!platform) return null;

  const titleKey=normalizeText(title);
  const platformKey=normalizeSystem(platform);
  if(!titleKey||!platformKey) return null;

  for(const group of data){
    if(normalizeSystem(group&&group.system)!==platformKey) continue;
    const games=Array.isArray(group&&group.games)?group.games:[];
    for(const item of games){
      if((item&&item.type||'game')!=='game') continue;
      if(normalizeText(item&&item.title)===titleKey) return item;
    }
  }
  return null;
}

function upgradeVerifiedSellCtas(){
  document.querySelectorAll('[data-z241-buylist-cta]').forEach(function(card){
    const title=(card.getAttribute('data-z241-title')||'').trim();
    const platform=(card.getAttribute('data-z241-platform')||'').trim();
    const match=exactBuyListMatch(title,platform);
    if(!match) return;

    const heading=card.querySelector('[data-z241-sell-heading]');
    const copy=card.querySelector('[data-z241-sell-copy]');
    const exactWrap=card.querySelector('[data-z241-exact-offer]');
    const link=card.querySelector('[data-z241-exact-link]');
    const linkLabel=card.querySelector('[data-z241-exact-link-label]');

    if(heading) heading.textContent='💵 Sell '+title+' to Zypher';
    if(copy){
      copy.innerHTML='Have <strong></strong>'+(platform?' for '+escapeHtml(platform):'')+' to sell? This exact title is currently on Zypher\'s live Buy List. Check the current offer, choose the condition that matches your copy, and add it directly to your sell list.';
      const strong=copy.querySelector('strong');
      if(strong) strong.textContent=title;
    }
    if(link){
      const params=new URLSearchParams({q:title,system:platform});
      link.href='/pages/buy-list?'+params.toString();
    }
    if(linkLabel) linkLabel.textContent='Check the current Buy List offer for '+title+' →';
    if(exactWrap) exactWrap.hidden=false;
    card.setAttribute('data-z241-exact-match','true');
  });
}

function escapeHtml(value){
  return String(value||'').replace(/[&<>"']/g,function(ch){
    return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[ch];
  });
}

if(document.readyState==='loading'){
  document.addEventListener('DOMContentLoaded',upgradeVerifiedSellCtas,{once:true});
}else{
  upgradeVerifiedSellCtas();
}
})();